import Popular from "../components/Popular";
import Veggie from "../components/Veggie";

const Home = () => {
  return (
    <div>
      <Popular />
      <Veggie />
    </div>
  );
};

export default Home;
